module.exports = __webpack_public_path__ + "img/gwen.ae2969e8.jpg";